export default __webpack_public_path__ + "static/media/6b7037f4-1d79-4c1d-98ac-88582ff8a377.d2046c0b.eot";